/* Atelier progressive enhancement. Native Turbo product/cart submissions remain authoritative. */
(() => {
  'use strict';
  if (window.VVAtelier) { window.VVAtelier.init(); return; }
  let cartObserver, observedCart;
  let instantBound = false;
  function compatibility() {
    const header = document.querySelector('#header.vva-header');
    const settings = window.Shopify && window.Shopify.theme_settings;
    if (header && settings) {
      if (header.dataset.vvaProductFormStyle) settings.product_form_style = header.dataset.vvaProductFormStyle;
      if (!settings.sold_out_text) settings.sold_out_text = header.dataset.vvaSoldOut || '';
    }
    const original = window.selectCallback;
    if (typeof original !== 'function' || original.vvaNullGuard) return;
    const guarded = function (variant, selector) {
      if (variant) return original.apply(this, arguments);
      if (!selector || !selector.product) return;
      const id = String(selector.product.id);
      if (!/^\d+$/.test(id)) return;
      const currentHeader = document.querySelector('#header.vva-header');
      const message = currentHeader && currentHeader.dataset.vvaUnavailable || 'Unavailable';
      document.querySelectorAll('.product-' + id).forEach(product => {
        product.querySelectorAll('.current_price,.was_price,.savings,.items_left').forEach(node => { node.textContent = ''; });
        product.querySelectorAll('.modal_price').forEach(node => node.classList.add('variant-unavailable'));
        product.querySelectorAll('.sold_out').forEach(node => { node.textContent = message; });
        product.querySelectorAll('.quantity').forEach(node => node.removeAttribute('max'));
        product.querySelectorAll('.add_to_cart').forEach(node => {
          node.disabled = true; node.classList.add('disabled');
          const label = node.querySelector('.text'); if (label) label.textContent = message;
        });
        product.querySelectorAll('.shopify-payment-button').forEach(node => node.classList.add('disabled'));
        product.querySelectorAll('.purchase-details__buttons').forEach(node => node.classList.add('product-is-unavailable'));
      });
    };
    guarded.vvaNullGuard = true;
    window.selectCallback = guarded;
  }
  function quantityLabels(root = document) {
    root.querySelectorAll('.js-change-quantity').forEach(control => {
      if (control.matches('button')) return;
      control.setAttribute('role','button'); control.tabIndex = 0;
      const input = control.parentElement.querySelector('input');
      if (!input) return;
      if (input.id) control.setAttribute('aria-controls', input.id);
      const label = input.getAttribute('aria-label') || (input.labels && input.labels[0] ? input.labels[0].textContent.trim() : input.name);
      control.setAttribute('aria-label', (control.dataset.func === 'minus' ? '− ' : '+ ') + label);
    });
  }
  function cartState() {
    const container = document.querySelector('.vva-native-cart');
    if (!container) return;
    const trigger = container.querySelector('.mini_cart');
    if (trigger) trigger.setAttribute('aria-expanded', String(container.classList.contains('active_link')));
    quantityLabels(container);
  }
  function closeCart(restoreFocus) {
    const container = document.querySelector('.vva-native-cart.active_link');
    if (!container) return;
    const trigger = container.querySelector('.mini_cart');
    container.classList.remove('active_link');
    if (trigger) trigger.classList.remove('active_link');
    if (!document.querySelector('.cart_container.active_link')) document.body.classList.remove('blocked-scroll','is-active');
    cartState();
    if (restoreFocus && trigger) trigger.focus();
  }
  function init() {
    compatibility();
    const target = document.querySelector('.js-product_section [data-product-form]');
    const bar = document.querySelector('[data-vva-mobile-buy]');
    if (target && bar) {
      if (!target.id) target.id = 'vva-product-options';
      const link = bar.querySelector('a'); if (link) link.href = '#' + target.id;
      bar.hidden = false; document.body.classList.add('vva-has-mobile-buy');
    } else document.body.classList.remove('vva-has-mobile-buy');
    quantityLabels();
    const container = document.querySelector('.vva-native-cart');
    if (container !== observedCart) {
      if (cartObserver) cartObserver.disconnect();
      observedCart = container;
      if (container && window.MutationObserver) {
        cartObserver = new MutationObserver(cartState);
        cartObserver.observe(container, { childList:true, subtree:true, attributes:true, attributeFilter:['class'] });
      }
    }
    cartState();
    if (!instantBound && window.InstantClick && typeof window.InstantClick.on === 'function') {
      window.InstantClick.on('change', init); instantBound = true;
    }
  }
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    document.querySelectorAll('.vva-header details[open]').forEach(detail => {
      if (!detail.contains(event.target)) detail.open = false;
    });
    if (event.target.closest('.vva-cart-close')) { event.preventDefault(); closeCart(true); }
    else if (!event.target.closest('.vva-native-cart')) closeCart(false);
    const link = event.target.closest('[data-vva-mobile-buy] a');
    if (link) {
      const target = document.getElementById(link.hash.slice(1));
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ block:'center', behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        const field = [...target.querySelectorAll('select,input:not([type=hidden]),button')].find(node => node.getClientRects().length && !node.disabled);
        if (field) field.focus({ preventScroll:true });
      }
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      document.querySelectorAll('.vva-header details[open]').forEach(detail => {
        if (detail.contains(document.activeElement)) detail.querySelector('summary').focus();
        detail.open = false;
      });
      closeCart(true);
    }
    if ((event.key === 'Enter' || event.key === ' ') && event.target instanceof Element && event.target.matches('.js-change-quantity[role=button]')) {
      event.preventDefault(); event.target.click();
    }
  });
  window.VVAtelier = { init };
  compatibility();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('pageshow', init);
  window.addEventListener('load', init);
  if (document.readyState !== 'loading') init();
})();
